













  












function getSearchParam(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

function isStoredCampaignActive() {
  let storedCampaignStarts = localStorage.getItem("specialCampaignFrom");
  let storedCampaignEnds = localStorage.getItem("specialCampaignTo");
  const today = new Date().getTime();
  const storedCampaignIsActive = today >= storedCampaignStarts && today <= storedCampaignEnds;
  return storedCampaignIsActive;
}

let param = getSearchParam('utm_promo');
const campaignStarts = new Date('2024-11-30 23:00:00').getTime();
const campaignEnds = new Date('2024-12-23 23:59:59').getTime();

// set a new campaign + dates

if (param == '17DEC.PITASGRINCH25') {
    console.info("new campaign detected");
    localStorage.setItem("specialCampaign", '17DEC.PITASGRINCH25');
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// refresh stored dates just in case

let storedSpecialCampaign = localStorage.getItem("specialCampaign");
if (storedSpecialCampaign == '17DEC.PITASGRINCH25') {
    console.info("campaign dates refreshed");
    localStorage.setItem("specialCampaignFrom", campaignStarts);
    localStorage.setItem("specialCampaignTo", campaignEnds);
}

// check if stored campaign is active
const storedCampaignIsActive = isStoredCampaignActive();

// change the buttons if it proceeds

if (storedSpecialCampaign == '17DEC.PITASGRINCH25' && storedCampaignIsActive == true) {
    document.querySelector('body').classList.add('_grinch-on');
    let logoMobile = document.querySelector('.header__mobile-logo');
    if (logoMobile){
      logoMobile.src = "//pitas-usa.com/cdn/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_small.gif";
      logoMobile.srcset = "//pitas-usa.com/cdn/shop/files/-small.png?v=1918 300w//pitas-usa.com/cdn/shop/files/-medium.png?v=1918 600w//pitas-usa.com/cdn/shop/files/-large.png?v=1918 1200w";
    }
    let logoDesktop = document.querySelector('.header__normal-logo');
    if (logoDesktop){
      logoDesktop.src = "//pitas-usa.com/cdn/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_small.gif";
      logoDesktop.srcset = "//pitas-usa.com/cdn/shop/files/-small.png?v=1918 300w//pitas-usa.com/cdn/shop/files/-medium.png?v=1918 600w//pitas-usa.com/cdn/shop/files/-large.png?v=1918 1200w";
    }
    let logoSticky = document.querySelector('.header__sticky-logo');
    if (logoSticky){
      logoSticky.src = "//pitas-usa.com/cdn/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_small.gif";
      logoSticky.srcset = "//pitas-usa.com/cdn/shop/files/-small.png?v=1918 300w//pitas-usa.com/cdn/shop/files/-medium.png?v=1918 600w//pitas-usa.com/cdn/shop/files/-large.png?v=1918 1200w";
    }    

    let topBar = document.querySelector('.top-bar');

    console.log("WMF topBar", topBar);

    let topBarMagic = document.querySelector('#withMagic');
    let topBarNoMagic = document.querySelector('#withoutMagic');
  
    if (topBar != null){
      topBar.style.backgroundColor = "#b0cd61";
    }   
    if (topBarMagic != null) {
          topBarMagic.style.display = "none";
    }
    if (topBarNoMagic != null) {
      topBarNoMagic.style.display = "block";
    } 
      
    let specialLabel = document.querySelector('#_special-collection-label');
    if (specialLabel) {
      specialLabel.style.display = "flex";  
    } 
  
    let specialCheckoutButton = document.querySelector("#_special-checkout-button");
    if (specialCheckoutButton) {
        specialCheckoutButton.style.display = "flex";
    }
  
    let specialRefreshButton = document.querySelector("#_special-refresh-button");
    if (specialRefreshButton) {
      specialRefreshButton.href = '&storefront=true';
      specialRefreshButton.style.display = "flex";  
    }
    
    let specialCartButton = document.querySelector("#_special-cart-button");
    if (specialCartButton) {
        specialCartButton.style.display = "block";
        let ordinaryCartButton = document.querySelector('a.t4s-btn__cart');
        ordinaryCartButton.style.display = "none";
    }

    let ordinaryCheckoutButton = document.querySelector('button[name="checkout"]');
    if (ordinaryCheckoutButton) {
      ordinaryCheckoutButton.style.display = "none";  
    }

    let bodyClasses = document.querySelector('body').classList;
    
  
    if(bodyClasses.contains("template-product")){
      let promoText = document.querySelector("._specialsales-promo-text");
      if (promoText) {
        promoText.style.display = "block";
      }
    }
    
    document.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel, index, array) {
      if ( isStoredCampaignActive()) {
        specialDiscountLabel.style.display = "block";    
      }
    });


    // infinite scroll tags
    const config = { childList: true, subtree: true }; 
    
    // Helper function to show discount labels in a node or its descendants
    const showDiscountLabels = function(node) {
      if (!isStoredCampaignActive()) return;
      
      // Check if node is an Element node
      if (node.nodeType === 1) {
        // If the node itself is a discount label, show it
        if (node.classList && node.classList.contains('_privatesale-discount')) {
          node.style.display = "block";
        }
        
        // Check all discount labels within this node (covers nested products and direct additions)
        node.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel) {
          specialDiscountLabel.style.display = "block";
        });
        
        // Also check if this node is inside a product container (covers cases where a small fragment is added)
        if (node.closest) {
          const parentProduct = node.closest('.t4s-product');
          if (parentProduct) {
            parentProduct.querySelectorAll('._privatesale-discount').forEach(function(specialDiscountLabel) {
              specialDiscountLabel.style.display = "block";
            });
          }
        }
      }
    };
    
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            showDiscountLabels(node);
          });
        }
      }
    }
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(document.body, config);
    
    }
